module.exports = __webpack_public_path__ + "img/EMT-OVCA_10X_OC.f996bfad.png";